import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const FEATURE_LIST_UNHIDDEN = 'FEATURE_LIST_UNHIDDEN';
export const FEATURE_LIST_SHOW_FAILED = 'FEATURE_LIST_SHOW_FAILED';

const showFeatureList = () => (
  (dispatch) => {
    return axios.post('/api/features/show-feature-list')
      .then(() => {
        dispatch({
          type: FEATURE_LIST_UNHIDDEN,
        });
      }).catch((error) => {
        dispatch({
          type: FEATURE_LIST_SHOW_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to show feature list',
          originalError: error,
        }));
      });
  }
);

export default showFeatureList;
